import React, { useEffect, useState } from "react";
import Preloading from "../../components/basics/Preloading";
import back from "../../assets/images/icons/arrow-right2.svg";
import { Link, useParams } from "react-router-dom";
import methods from "../../services/utility";
import apiMethod from "../../services/api-service";
import Paginations from "../../components/paginaton/Paginations";
import DeleteModal from "../../components/deleteModal/DeleteModal";

const CreateCategoryWarhouse = () => {
  const { branchId , restaurantId } = useParams();
  const [loading, setLoading] = useState();
  const [gridData, setGridData] = useState([]);
  const [totalPages, setTotalPages] = useState(null);
  const [createCatetoryModal, setCreateCategoryModal] = useState(false);
  const [editCategoryModal, setEditCategoryModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    restaurantId: restaurantId,
    parentId: null,
    title: "",
    code: "",
    size: 20,
    part: 1,
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    title: "",
    code: "",
    description: "",
    parentId: null,
    branchId: branchId,
    restaurantId: restaurantId,
  });

  const resetForm = () => {
    setFormModel({
      id: 0,
      title: "",
      code: "",
      description: "",
      parentId: null,
      branchId: branchId,
      restaurantId: restaurantId,
    });
  };

  const resetFilters = () => {
    setFilterModel({
      branchId: branchId,
      restaurantId: restaurantId,
      parentId: null,
      title: "",
      code: "",
      size: 20,
      part: 1,
    });
  };

  const getGridData = async () => {
    setLoading(true);
    const resp = await apiMethod.getWarehouseCategories(
      filterModel.branchId,
      filterModel.restaurantId,
      filterModel.title,
      filterModel.size,
      filterModel.part
    );
    if (methods.showApiErrors(resp)) {
      setTotalPages(resp.total);
      setGridData(resp.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getGridData();
      setLoading(false);
    };
    bindData();
  }, []);

  const callPager = async (i) => {
    setLoading(true);
    setFilterModel({ ...filterModel, part: i });
    await getGridData();
    setLoading(false);
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };
  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    resetForm();
  };

  const closeCreateModal = () => {
    setCreateCategoryModal(false);
    resetForm();
  };

  const closeEditModal = () => {
    setEditCategoryModal(false);
    resetForm();
  };

  const editItem = async (id) => {
    setEditCategoryModal(true);
    setLoading(true);
    const resp = await apiMethod.getWarehouseCategoryInfo(id);
    if (methods.showApiErrors(resp)) {
      setFormModel({
        ...formModel,
        id: resp.data.id,
        title: resp.data.title,
        description: resp.data.description,
        code: resp.data.code,
      });
    }
    setLoading(false);
  };

  const selectItemToDelete = (item) => {
    setFormModel(item);
    setShowDeleteModal(true);
  };

  const handleCreateModal = () => {
    setCreateCategoryModal(true);
    resetForm();
  };

  const addCategory = async () => {
    setLoading(true);
    const resp = await apiMethod.createWarehouseCategory(formModel);
    if (methods.showApiErrors(resp)) {
      setCreateCategoryModal(false);
      setEditCategoryModal(false);
      resetForm();
      await getGridData();
    }
    setLoading(false);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeWarehouseCategory(formModel.id);
      if (!methods.showApiErrors(resp)) return false;

      await getGridData();
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading />}
        <div className="d-none d-lg-block mb-3">
          <Link
            to={`/warehouse/${restaurantId}/${branchId}`}
            className="text-start mb-3 link back-link"
          >
            <span>
              <img src={back} alt="return" />
            </span>
            بازگشت
          </Link>
        </div>
        <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
          <div>
            <Link
              to={`/warehouse/${restaurantId}/${branchId}`}
              className="link back-link"
            >
              <span>
                <img src={back} alt="return" />
              </span>
            </Link>
            دسته بندی انبار
          </div>
          <p className="date">{methods.currentDate()}</p>
        </div>
        <div className="saleheader d-none d-lg-block">
          <p>
            دسته بندی انبار
            <a
              href={`/sale/${branchId}/softwareGuide/#section7`}
              className="link rtlicon me-1"
              title="برای اطلاعات بیشتر کلیک کنید"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="bi bi-question-circle"></i>
            </a>
          </p>
        </div>
        <div className="salemain">
          <div className="salesearchsection">
            <div className="row g-1">
              <div className="col-12 col-md-6 col-lg-3">
                <label htmlFor="searchInput" className="form-label">
                  عنوان
                </label>
                <input
                  id="searchInput"
                  className="form-control"
                  type="text"
                  style={{ direction: "rtl", textAlign: "right" }}
                  value={filterModel.title}
                  onChange={(e) =>
                    setFilterModel({
                      ...filterModel,
                      title: e.target.value,
                      part: 1,
                    })
                  }
                />
              </div>
              <div className="col-2 d-flex align-items-end" style={{ marginBottom: "4px" }}>
                <button
                  type="button"
                  className="btn btn-purple me-1"
                  onClick={searchItem}
                >
                  <i className="bi bi-search"></i>
                </button>
                <button
                  type="button"
                  className="btn btn-outline-info"
                  onClick={clearSearch}
                >
                  <i className="bi bi-arrow-clockwise"></i>
                </button>
              </div>
              <div className="col-12 col-md-6 col-lg-7">
                <div className="createButton">
                  <button
                    className="btn btn-outline-purple custome-btn"
                    type="button"
                    onClick={handleCreateModal}
                  >
                    <span className="align-middle d-inline-block">
                      دسته بندی انبار جدید
                    </span>{" "}
                    <i className="bi bi-plus-circle align-middle"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="table-responsive saletable">
            <table className="table table-striped table-md">
              <thead>
                <tr>
                  <th scope="col" width="20px">
                    ردیف
                  </th>
                  <th scope="col">عنوان</th>
                  <th scope="col" width="100px">
                    عملیات
                  </th>
                </tr>
              </thead>
              <tbody>
                {gridData.map((item, index) => (
                  <tr key={item.id}>
                    <td>
                      {(filterModel.part - 1) * filterModel.size + index + 1}
                    </td>
                    <td>{item.title}</td>
                    <td>
                      <button
                        onClick={() => editItem(item.id)}
                        className="btn btn-sm btn-outline-purple me-2"
                        type="button"
                      >
                        <i className="bi bi-pencil-square"></i>
                      </button>
                      <button
                        onClick={() => selectItemToDelete(item)}
                        className="btn btn-sm btn-outline-danger"
                        type="button"
                      >
                        <i className="bi bi-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {filterModel.part > 1 && (
              <div className="pagination justify-content-center mt-5">
                <Paginations
                  total={totalPages}
                  size={filterModel.size}
                  onPageChange={callPager}
                />
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  const createCategoryModalInfo = () => (
    <div
      className="modal fade show"
      tabIndex="-1"
      role="dialog"
      style={{ display: "block" }}
      onClick={closeCreateModal}
    >
      <div
        className="modal-dialog modal-md modal-dialog-centered"
        role="document"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content px-3">
          <div className="modal-header">
            <h5 className="modal-title">افزودن دسته بندی جدید</h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={closeCreateModal}
            ></button>
          </div>
          <div className="modal-body">
            <div className="col-12 mb-4">
              <label className="form-label">عنوان</label>
              <input
                className="form-control"
                type="text"
                style={{ direction: "rtl", textAlign: "right" }}
                value={formModel.title}
                onChange={(e) =>
                  setFormModel({ ...formModel, title: e.target.value })
                }
              />
            </div>
            <div className="col-12">
              <label className="form-label">توضیحات</label>
              <textarea
                className="form-control"
                rows={4}
                style={{ direction: "rtl", textAlign: "right" }}
                value={formModel.description}
                onChange={(e) =>
                  setFormModel({ ...formModel, description: e.target.value })
                }
              ></textarea>
            </div>
            <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
              <button
                type="button"
                className="btn custome-btn btn-link-purple"
                onClick={closeCreateModal}
              >
                انصراف
              </button>
              <button
                type="button"
                className="btn custome-btn btn-purple"
                onClick={addCategory}
              >
                ثبت و ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const editCategoryModalInfo = () => (
    <div
      className="modal fade show"
      tabIndex="-1"
      role="dialog"
      style={{ display: "block" }}
      onClick={closeEditModal}
    >
      <div
        className="modal-dialog modal-md modal-dialog-centered"
        role="document"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content px-3">
          <div className="modal-header">
            <h5 className="modal-title">ویرایش دسته بندی</h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={closeEditModal}
            ></button>
          </div>
          <div className="modal-body">
            <div className="col-12 mb-4">
              <label className="form-label">عنوان</label>
              <input
                className="form-control"
                type="text"
                style={{ direction: "rtl", textAlign: "right" }}
                value={formModel.title}
                onChange={(e) =>
                  setFormModel({ ...formModel, title: e.target.value })
                }
              />
            </div>
            <div className="col-12">
              <label className="form-label">توضیحات</label>
              <textarea
                className="form-control"
                rows={4}
                style={{ direction: "rtl", textAlign: "right" }}
                value={formModel.description}
                onChange={(e) =>
                  setFormModel({ ...formModel, description: e.target.value })
                }
              ></textarea>
            </div>
            <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
              <button
                type="button"
                className="btn custome-btn btn-link-purple"
                onClick={closeEditModal}
              >
                انصراف
              </button>
              <button
                type="button"
                className="btn custome-btn btn-purple"
                onClick={addCategory}
              >
                ثبت و ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      {renderItems()}
      {createCatetoryModal && createCategoryModalInfo()}
      {editCategoryModal && editCategoryModalInfo()}
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDeleteModal}
          deleteItem={deleteItem}
          text={"دسته بندی انبار"}
        />
      )}
    </div>
  );
};

export default CreateCategoryWarhouse;
